import "toastr/build/toastr.min.css";
import { toast } from "react-toastify";
import { CLIENT_JOB_DESCRIPTION } from "../config/apiEndPoint";
import { DEL, GET, POST } from "config/api.config";
import { shortenCommonLink } from "./MetaModel";

export { shortenCommonLink };

export const getClientJobDescriptionList = async (data = {}) => {
  try {
    const url = data?._Id
      ? `${CLIENT_JOB_DESCRIPTION.GET_CLIENT_JOB_DESCRIPTION_LIST}/${data?._Id}`
      : `${CLIENT_JOB_DESCRIPTION.GET_CLIENT_JOB_DESCRIPTION_LIST}`;
    const response = await GET(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const fetchClientJobDescriptionTableAndFilterSchema = async (data = {}) => {
  try {
    const url = data?._Id
      ? `${CLIENT_JOB_DESCRIPTION.GET_CLIENT_JOB_DESCRIPTION_SCHEMA}/${data?._Id}`
      : `${CLIENT_JOB_DESCRIPTION.GET_CLIENT_JOB_DESCRIPTION_SCHEMA}`;
    const response = await GET(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const submitClientJobDescriptionFilterData = async (data = {}) => {
  try {
    const response = await POST(CLIENT_JOB_DESCRIPTION.SUBMIT_FILTER_DATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const upsertClientJobDescription = async (data = {}) => {
  try {
    const response = await POST(CLIENT_JOB_DESCRIPTION.UPSERT_CLIENT_JOB_DESCRIPTION, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const getClientJobDescriptionForEdit = async (clientId, jobId = "") => {
  try {
    const baseUrl = `${CLIENT_JOB_DESCRIPTION.GET_CLIENT_JOB_DESCRIPTION_FOR_EDIT}/${clientId}`;
    const url = jobId ? `${baseUrl}?jobId=${encodeURIComponent(jobId)}` : baseUrl;
    const response = await GET(url, {});
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** DELETE `client/ClientJobDescription/{id}` */
export const deleteClientJobDescription = async (id = "") => {
  const raw = String(id ?? "").trim();
  if (!raw) {
    toast.error("Job description ID is required");
    return;
  }
  try {
    const response = await DEL(CLIENT_JOB_DESCRIPTION.DELETE_CLIENT_JOB_DESCRIPTION(raw));
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};
